import { css } from '@emotion/react'
import { Button } from 'components/button/Button'
import PerkCard from 'components/content/planPerks/perkCard/PerkCard'
import {
  PerkCardsContainer,
  PlanPerksContainer,
  SStack,
  WidthControlledText,
} from './PlanPerks.styled'
import { Icon } from 'components/icon'
import { HStack, Stack } from 'components/Stack'
import { Caption, Title, Title_h4_default } from 'components/Typography'
import CyberscoutSquare from 'images/extra-svg/CyberscoutSquare.svg'
import Dashlane from 'images/extra-svg/Dashlane.svg'
import Goodtrust from 'images/extra-svg/Goodtrust.svg'
import { useTranslation } from 'next-i18next'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { colors } from 'utils/colors'
import { numberRange } from 'utils/general'
import { mapKeysToTrans } from 'utils/i18n/mapKeysToTrans'

const PlanPerks = () => {
  const { t } = useTranslation()
  const { t: tPricing } = useTranslation('pricing_plan')
  const { isLogged } = useAuth()
  const freePerks = mapKeysToTrans(
    tPricing,
    numberRange(5).map((i) => `pricing_plan.free_perks.perk_${i}` as const)
  )
  const dashlanePerks = mapKeysToTrans(
    tPricing,
    numberRange(5).map((i) => `pricing_plan.dashlane_perks.perk_${i}` as const)
  )
  const cyberscoutPerks = mapKeysToTrans(
    tPricing,
    numberRange(5).map((i) => `pricing_plan.cyberscout_perks.perk_${i}` as const)
  )

  return (
    <PlanPerksContainer space={['1rem', '2rem']}>
      <SStack space={['1rem', '1.5rem']}>
        <Caption>{t('common.section_digital_protection_perks.caption')}</Caption>
        <Title variant={Title_h4_default}>
          {t('common.section_digital_protection_perks.title')}
        </Title>
        <WidthControlledText>
          {t('common.section_digital_protection_perks.description')}
        </WidthControlledText>
      </SStack>
      <PerkCardsContainer space={'2rem'}>
        <PerkCard
          type="free"
          icon={<Goodtrust />}
          title="Digital Vault"
          perks={freePerks}
          href="/digital-vault"
        />
        <PerkCard
          type="premium"
          icon={<Dashlane />}
          title="Password Manager"
          perks={dashlanePerks}
          href="dashlane-password-manager"
        />
        <PerkCard
          type="premium"
          icon={<CyberscoutSquare />}
          title="Digital Insurance"
          perks={cyberscoutPerks}
          href="cyberscout-coverage"
        />
      </PerkCardsContainer>
      <Stack
        space="1rem"
        css={css`
          align-items: center;
        `}
      >
        <Button
          type="button"
          size="large"
          tone="dark"
          href={isLogged ? '/me/dashboard' : '/signup'}
        >
          {t('common.section_digital_protection_perks.primary_cta')}
        </Button>
        <HStack>
          <Button type="button" variant="text" tone="dark" href="/pricing">
            {t('common.section_digital_protection_perks.secondary_cta')}
          </Button>
          <Icon name="ArrowRight" color={colors.black} />
        </HStack>
      </Stack>
    </PlanPerksContainer>
  )
}

export default PlanPerks
